import {
  VpBadge,
  VpRadioGroupChip,
  VpRadioGroupChipItem,
  VpRadioGroupChipItemLabel,
} from '@vtmn-play/react'
import { VpDivider } from '@vtmn-play/react/VpDivider'
import { useTranslation } from 'react-i18next'
import { useMemo } from 'react'
import { trackEvent } from '@/src/analytics/amplitude'

export type HomeTab = 'diagnosis' | 'actions' | 'history'

type HomeTabsProps = {
  value: HomeTab
  onChange: (value: HomeTab) => void
  actionsToDoCount?: number
}

const HomeTabs = ({ value, onChange, actionsToDoCount }: HomeTabsProps) => {
  const actionBadge = useMemo(
    () =>
      actionsToDoCount ? (
        <VpBadge
          data-testid="count-actions-badge"
          className="absolute! -top-2 -right-2 h-6 w-6"
          variant={'primary'}
        >
          {actionsToDoCount}
        </VpBadge>
      ) : (
        <></>
      ),
    [actionsToDoCount]
  )
  const { t } = useTranslation('common')

  const handleTabChange = (tab: HomeTab) => {
    if (tab == 'history') trackEvent('HISTORY_TAB_CLICK')
    if (tab == 'actions') trackEvent('ACTION_TAB_CLICK')

    onChange(tab)
  }
  return (
    <div>
      <VpRadioGroupChip
        value={value}
        onChange={(e) => handleTabChange(e.currentTarget.value as HomeTab)}
        className="flex w-full gap-2"
      >
        <VpRadioGroupChipItem
          className="flex-1/3 min-w-0 justify-center whitespace-nowrap"
          value={'diagnosis'}
          data-testid="home-tab-diagnosis-button"
          labelSlot={<VpRadioGroupChipItemLabel>{t('global.diagnosis')}</VpRadioGroupChipItemLabel>}
        />

        <VpRadioGroupChipItem
          className="flex-1/3 justify-center"
          data-testid="home-tab-actions-button"
          value={'actions'}
          labelSlot={
            <>
              <VpRadioGroupChipItemLabel>{t('global.actions')}</VpRadioGroupChipItemLabel>
              {actionBadge}
            </>
          }
        />

        <VpDivider orientation={'vertical'} />

        <VpRadioGroupChipItem
          className="flex-1/3 min-w-0 justify-center whitespace-nowrap"
          value={'history'}
          data-testid="home-tab-history-button"
          labelSlot={<VpRadioGroupChipItemLabel>{t('global.history')}</VpRadioGroupChipItemLabel>}
        />
      </VpRadioGroupChip>
    </div>
  )
}

export default HomeTabs
